module.exports = __webpack_public_path__ + "static/img/result@2x.c9fdbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/result@2x.png
// module id = X0bc
// module chunks = 1